import { ActivityInvitationType, ActivityType } from '.';
import { ActivityOwner } from '.';

export class ActivityListing
{
    constructor(
        public id:string,
        public activityType:ActivityType,
        public invitationType:ActivityInvitationType,
        public title:string,
        public description:string,
        public start:Date,
        public end:Date,
        public location:string,
        public workgroupId:string,
        public workgroupName:string,
        public owner:ActivityOwner | null,

        // unique to ActivityListing (vs Activity)
        public participantCount:number
    ){}
}